import React from 'react';
import { Link } from 'react-router-dom';
import { FiBell, FiSearch } from 'react-icons/fi';
import { Badge, Kbd, cn } from '../ui';
import Breadcrumb from './Breadcrumb';
import UserMenu from './UserMenu';

/**
 * TopBar — sticky header above the content area.
 * Left:  breadcrumbs
 * Right: search trigger (⌘K) → opens CommandPalette · notifications · user menu
 */
export function TopBar({ onOpenPalette, pendingRequests, theme, onToggleTheme }) {
  const isMac =
    typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);

  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex h-14 shrink-0 items-center gap-3 px-5',
        'border-b border-line bg-surface/80 backdrop-blur',
      )}
    >
      <div className="min-w-0 flex-1">
        <Breadcrumb />
      </div>

      <button
        type="button"
        onClick={onOpenPalette}
        className={cn(
          'inline-flex h-8 items-center gap-2 rounded-md border border-line bg-surface pl-2.5 pr-1.5',
          'text-body-sm text-fg-muted transition-colors hover:bg-ink-50 hover:text-fg',
          'focus-visible:outline-none focus-visible:shadow-focus-ring',
        )}
        aria-label="Open command palette"
      >
        <FiSearch size={14} className="text-fg-subtle" aria-hidden />
        <span className="hidden sm:inline">Search</span>
        <Kbd className="hidden sm:inline-flex">{isMac ? '⌘' : 'Ctrl'}</Kbd>
        <Kbd className="hidden sm:inline-flex">K</Kbd>
      </button>

      <Link
        to="/client-requests"
        title="Pending requests"
        className={cn(
          'relative inline-flex h-8 w-8 items-center justify-center rounded-md',
          'text-fg-muted transition-colors hover:bg-ink-50 hover:text-fg',
          'focus-visible:outline-none focus-visible:shadow-focus-ring',
        )}
      >
        <FiBell size={16} />
        {pendingRequests > 0 && (
          <Badge
            variant="danger"
            size="sm"
            className="absolute -right-1.5 -top-1 h-4 min-w-[16px] justify-center px-1 text-[9px] ring-2 ring-surface"
          >
            {pendingRequests > 99 ? '99+' : pendingRequests}
          </Badge>
        )}
      </Link>

      <UserMenu theme={theme} onToggleTheme={onToggleTheme} />
    </header>
  );
}

export default TopBar;
